import React from 'react'

const TextPreview: React.FC<{
    content: string
}> = (props) => <div>{props.content}</div>

export default React.memo(TextPreview)
